"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceUtils = void 0;
/**
 * `PriceUtils` provide utility methods for prices
 */
class PriceUtils {
    /**
     * Retrieves whether a `Price` has any value set for any currency
     *
     * @param price The `Price` to check
     * @returns Whether it has a price or not
     */
    static priceHasAnyCurrencySet(price) {
        if (!price)
            return false;
        for (const currency in price) {
            if (price[currency] != null) {
                return true;
            }
        }
        return false;
    }
    /**
     * Retrieves whether a `CountryPrice` has any value set for any currency
     *
     * @param countryPrice The `CountryPrice` to check
     * @returns Whether it has any price set or not
     */
    static countryPriceHasAnyCurrencySet(countryPrice) {
        if (!countryPrice || !countryPrice.Countries) {
            return false;
        }
        for (const country in countryPrice.Countries) {
            if (PriceUtils.priceHasAnyCurrencySet(countryPrice.Countries[country])) {
                return true;
            }
        }
        return false;
    }
    /**
     * Retrieves whether two prices euqal or not
     *
     * @param price1 One price to compare
     * @param price2 The other price to compare
     * @returns Whether they are equal or not
     */
    static pricesEqual(price1, price2) {
        // both are null or undefined
        if (price1 == null && price2 == null)
            return true;
        // ensure both are defined
        if (price1 == null && price2 != null)
            return false;
        if (price1 != null && price2 == null)
            return false;
        for (const currency in price1) {
            // ensure that all currencies of 1st are set in 2nd
            if (!(currency in price2))
                return false;
        }
        // eslint-disable-next-line
        for (const currency in price2) {
            // ensure that all currencies of 2nd are set in 1st
            if (!(currency in price1))
                return false;
            // ensure that all values equal
            if (price1[currency] !== price2[currency])
                return false;
        }
        return true;
    }
    /**
     * Retrieves whether two country prices euqal or not
     *
     * @param cp1 One country price to compare
     * @param cp2 The other country price to compare
     * @returns Whether they are equal or not
     */
    static countryPricesEqual(cp1, cp2) {
        // both are null or undefined
        if (cp1 == null && cp2 == null)
            return true;
        // ensure both are defined
        if (cp1 == null && cp2 != null)
            return false;
        if (cp2 == null && cp1 != null)
            return false;
        // ensure both have Countries defined
        if (cp1.Countries == null && cp2.Countries != null)
            return false;
        if (cp1.Countries != null && cp2.Countries == null)
            return false;
        for (const country in cp1.Countries) {
            // ensure that all countries of 1st are set in 2nd
            if (!(country in cp2.Countries))
                return false;
        }
        // eslint-disable-next-line
        for (const country in cp2.Countries) {
            // ensure that all currencies of 2nd are set in 1st
            if (!(country in cp1.Countries))
                return false;
            // ensure that all values equal
            if (!PriceUtils.pricesEqual(cp1.Countries[country], cp2.Countries[country]))
                return false;
        }
        return true;
    }
    /**
     * Safely sets a value in a `CountryPrice` object
     *
     * @param countryPrice The object to set the value for
     * @param country The country to use
     * @param currency The currency to use
     * @param price The price to set
     * @returns The set `CountryPrice`
     */
    static setCountryPrice(countryPrice, country, currency, price) {
        countryPrice = countryPrice || { Countries: {} };
        countryPrice.Countries[country] = countryPrice.Countries[country] || {};
        countryPrice.Countries[country][currency] = price;
        return countryPrice;
    }
    /**
     * Safely retrieves a value of a `CountryPrice` object
     *
     * @param countryPrice The object to set the value for
     * @param country The country to use
     * @param currency The currency to use
     * @return The price value
     */
    static getCountryPrice(countryPrice, country, currency) {
        return countryPrice &&
            countryPrice.Countries &&
            countryPrice.Countries[country] &&
            countryPrice.Countries[country][currency] != null
            ? countryPrice.Countries[country][currency]
            : undefined;
    }
}
exports.PriceUtils = PriceUtils;
//# sourceMappingURL=PriceUtils.js.map